module.exports = __webpack_public_path__ + "img/70100013.83e28d65.png";